module.exports = __webpack_public_path__ + "img/logo-stonebridge.16144abc.png";